export default {
	key: 'rockPaperScissors',
	paths: ['Score.score'],
};
